import { MenuItem } from '@mui/material';
import { CustomSelect, HorizontalForm } from '../../../../common/components';

const QualityCommentsFilters = ({
  allotments,
  lots,
  selectedAllotment,
  selectedLot,
  onSelectAllotment,
  onSelectLot,
}) => {
  return (
    <HorizontalForm>
      <CustomSelect
        label="Loteo"
        name="uuid_allotment"
        value={selectedAllotment || ''}
        onChange={onSelectAllotment}
        size="medium"
        sx={{maxWidth:'400px', mr: 2}}
      >
        <MenuItem value="">Todos</MenuItem>
        {(allotments || []).map((allotment) => (
          <MenuItem key={allotment.uuid} value={allotment.uuid}>
            {allotment.name}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomSelect
        label="Lote"
        name="uuid_lot"
        value={selectedLot || ''}
        onChange={onSelectLot}
        size="medium"
        disabled={!selectedAllotment}
        sx={{maxWidth:'200px'}}
      >
        <MenuItem value="">Todos</MenuItem>
        {(lots || []).map((lot) => (
          <MenuItem key={lot.uuid} value={lot.uuid}>
            {(lot.block_number || '').trim()}
            {lot.block_number ? '-' : ''}
            {(lot.lot_number || '').trim()}
          </MenuItem>
        ))}
      </CustomSelect>
    </HorizontalForm>
  );
};

export default QualityCommentsFilters;
